import { query, orderBy, startAt, endAt, getDocs } from "firebase/firestore";

import { useMemo } from "react";

import { orderBy as orderBy_ } from "lodash";

import * as geofire from "geofire-common";

import { locationsCollection } from "@/modules/firebase";
import { Location } from "@/modules/shared/shared.types";
import { useApiNearbyLocationsByProject } from "@/api/project.api";
import { useProjectsStore } from "@/core/stores/projects.store";
import { usePreferenceStore } from "@/core/stores/preference.store";

// const apiMymap =

type UseLocationsHelpersParams = {
  nearbyLocation?: {
    lat: number;
    long: number;
  } | null;
};

// hook
export function useLocationsHelpers(params?: UseLocationsHelpersParams) {
  const loc = params?.nearbyLocation;
  const currentProject = useProjectsStore((state) => state.currentProject);
  const projectId = currentProject?.id;
  const nearbyLocationsCount = usePreferenceStore(
    (state) => state.locationsNearbyCount,
  );

  const hasValidLocation = loc != null && (loc.lat !== 0 || loc.long !== 0);

  const hasValidProjectId = projectId != null && projectId !== "";

  const nearbyLocationsQueryApi = useApiNearbyLocationsByProject({
    projectId: projectId ?? "",
    lat: loc?.lat ?? 0,
    long: loc?.long ?? 0,
    enabled: hasValidLocation && hasValidProjectId,
  });
  const getNearbyShultersByRadius = async (location: {
    lat: number;
    long: number;
  }) => {
    // const centerPoint = new GeoPoint(33.07519298, 35.1539344); // Replace with your center point's latitude and longitude
    const centerPoint: [number, number] = [location.lat, location.long]; // Replace with your center point's latitude and longitude
    const radiusInM = 400; // on meters

    // Each item in 'bounds' represents a startAt/endAt pair. There can be up to 9 pairs of bounds
    // depending on overlap, but in most cases there are 4.
    const bounds = geofire.geohashQueryBounds(centerPoint, radiusInM);
    const promises = bounds.map((b) =>
      getDocs(
        query(
          locationsCollection,
          orderBy("coordsHash"),
          startAt(b[0]),
          endAt(b[1]),
        ),
      ),
    );

    const snapshots = await Promise.all(promises);

    const models: Location[] = snapshots
      .flatMap((snap) => snap.docs)
      .reduce<Location[]>((acc, doc) => {
        const { id, description, imgsUrls, coords, coordsHash } = doc.data();
        const { latitude: lat, longitude: lng } = coords;

        // Filter out GeoHash false positives
        const distanceInM =
          geofire.distanceBetween([lat, lng], centerPoint) * 1000;

        if (distanceInM <= radiusInM) {
          acc.push({
            id,
            description,
            imagesUrls: imgsUrls,
            coords: { lat, longt: lng, hash: coordsHash },
            distance: 0,
          });
        }

        return acc;
      }, []);

    return models;
  };

  const nearbyLocations = useMemo(() => {
    const data = nearbyLocationsQueryApi.data;
    if (!data) return [];
    const ordered = orderBy_(data, "distance", "asc");
    return ordered.slice(0, nearbyLocationsCount);
  }, [nearbyLocationsQueryApi.data, nearbyLocationsCount]);

  return {
    getNearbyShultersByRadius,
    nearbyLocations,
    isLoadingNearby: nearbyLocationsQueryApi.isLoading,
  };
}
